export function legacyRequestFromApi(r) {
  return {
    servicerequestid: r.id,
    title: r.title,
    description: r.description,
    status: r.status,
    bidtype: r.bidType,
    receivingmethod: r.receivingMethod,
    serviceabletime: r.serviceableTime,
    serviceid: r.serviceId,
    attachments: (r.attachments || []).map((a) => ({
      srattachmentid: a.id,
      name: a.name,
      type: a.type,
      filesize: a.fileSize,
    })),
  };
}

export function legacyOfferListFromApi(o) {
  return {
    servicerequestofferid: o.id,
    servicerequestid: o.requestId,
    offerprice: o.offerPrice,
    offertype: o.offerType,
    currency: o.currency,
    status: o.status,
    created_at: o.createdAt,
    servicerequesttitle: o.requestTitle,
    servicerequestdescription: o.requestDescription,
    servicerequeststatus: o.requestStatus,
    servicename: o.serviceName,
    createdbyuserid: o.consumerId,
    createdbyfname: o.consumerFirstName,
    createdbymname: o.consumerMiddleName,
    createdbylname: o.consumerLastName,
  };
}
